import React from 'react';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

export default function TextArea_Simple(props) {
  const handleOnKeyUp  = (event) => {
    if (props.triggerUpdateInParent) props.triggerUpdateInParent(props.id, event.target.value)
  }
  return (
    <>
    {props.classesToAdd == "required-adjusted-textarea-before" ? <span className={props.classesToAdd}></span> : <></>}
    <TextareaAutosize 
      style={{width:'100%', paddingLeft: '10px', paddingTop: '2px'}} 
      aria-label="" 
      defaultValue={props.valueInField}
      minRows={3} 
      rows={props.rows} 
      maxRows={props.maxRows} 
      placeholder={props.placeholder} 
      onKeyUp={handleOnKeyUp}
    />
    {/*props.classesToAdd != "required-adjusted-textarea-before" ? <span className={props.classesToAdd}></span> : <></>*/}
    {props.required ? <span className="required-field-textarea">*</span> : <span className="unrequired-field">*</span>}
    </>
  );
}